import { render, staticRenderFns } from "./FooterNewsLatter.vue?vue&type=template&id=67612463&"
import script from "./FooterNewsLatter.vue?vue&type=script&lang=js&"
export * from "./FooterNewsLatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports